import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiResponse, PaginatedPayload } from "../../types/ApiResponse";
import {
  getClientsApi,
  addNewClientApi,
  updateClientApi,
  deleteClientApi,
  getClientDetailsApi,
} from "../../helpers/ApiManager";
import {
  ClientsPayloadData,
  ClientsQueryParams,
  AddClientFormParams,
  EditClientFormParams,
  ClientDetailsPayload,
} from "types/client.api";
import { ErrorHandler, SuccessToast, ToastFactory } from "utils/toast";

export const getClients = createAsyncThunk<
  ApiResponse<PaginatedPayload<ClientsPayloadData>>, // return type
  ClientsQueryParams | undefined, // argument type
  { rejectValue: string } // rejected type
>("clients/getClients", async (params, { rejectWithValue }) => {
  try {
    const response = await getClientsApi(params);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const getClientDetails = createAsyncThunk<
  ApiResponse<ClientDetailsPayload>, // return type
  number, // argument type
  { rejectValue: string } // rejected type
>("clients/getClientDetails", async (params, { rejectWithValue }) => {
  try {
    console.log("getClientDetails", params);
    const response = await getClientDetailsApi(params);
    console.log("getClientDetails", response);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch by id");
  }
});

export const addNewClient = createAsyncThunk<
  ApiResponse<ClientsPayloadData>, // return type
  AddClientFormParams, // argument type
  { rejectValue: string } // rejected type
>("clients/addClient", async (data, { rejectWithValue }) => {
  try {
    const response = await addNewClientApi(data);
    console.log("response", JSON.stringify(response, null, 2));
    SuccessToast(response.message || "Contact added successfully");
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    console.log("Error occurs", err);
    return rejectWithValue(err?.message || "Failed to create");
  }
});

export const updateClient = createAsyncThunk<
  ApiResponse<ClientsPayloadData>, // return type
  EditClientFormParams, // argument type
  { rejectValue: string } // rejected type
>("clients/updateClient", async (data, { rejectWithValue }) => {
  try {
    const response = await updateClientApi(data);

    toast.success("Contact Updated Successfully", { autoClose: 3000 });
    return response;
  } catch (err: any) {
    toast.error("Contact Updated Failed", { autoClose: 3000 });
    return rejectWithValue(err?.message || "Failed to update");
  }
});

export const deleteClient = createAsyncThunk<
  ApiResponse<number>, // return type
  number, // argument type
  { rejectValue: string } // rejected type
>("clients/deleteClient", async (clientId, { rejectWithValue }) => {
  try {
    const response = await deleteClientApi(clientId);
    response.payload = clientId;
    ToastFactory("Client", "Delete", true);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to delete");
  }
});
